//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBarForm from '~/components/form/search-bar-form.vue'

export default {
  name: 'PageTop',
  components: { SearchBarForm },
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    withSearchBar: {
      type: Boolean,
      default: false
    }
  }
}
